module.exports = __webpack_public_path__ + "static/media/close-icon.d1f010c7.svg";